import { commonTheme } from './common-theme';
export const bannerLightTheme = {
    ...commonTheme,
};
//# sourceMappingURL=light-theme.js.map